export const FULLSCREEN_EVENT = 'herond:fullscreen';

export interface FullscreenEventDetail {
  active: boolean;
}

/**
 * Dispatch a fullscreen toggle event to the host-ui shell.
 * MFE modules call this to request the shell to hide/show Header + Sidebar.
 * Uses native CustomEvent so no cross-module React imports are needed.
 */
export const dispatchFullscreen = (active: boolean): void => {
  window.dispatchEvent(
    new CustomEvent<FullscreenEventDetail>(FULLSCREEN_EVENT, {
      detail: { active },
    }),
  );
};
